class AppConfig {
  
  private encryptionKey = "";
  private datdogClientToken = "";

  setEncryptionKey(key: string) {
    this.encryptionKey = key;
  }

  getEncryptionKey(): string {
    return this.encryptionKey;
  }

  setDatadogClientToken(token: string) {
    this.datdogClientToken = token;
  }

  getDatadogClientToken(): string {
    return this.datdogClientToken;
  }

}

export const appConfig = new AppConfig();